import { render, staticRenderFns } from "./CmgAccountModalRewardsStore.vue?vue&type=template&id=1bf94b3b&scoped=true&lang=pug"
import script from "./cmg-account-modal-rewards-store.ts?vue&type=script&lang=ts&external"
export * from "./cmg-account-modal-rewards-store.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAccountModalRewardsStore.vue?vue&type=style&index=0&id=1bf94b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf94b3b",
  null
  
)

export default component.exports